import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ServerService } from "src/app/services/server.service";
import {
  MatDialog,
  MatDialogRef,
  MatSnackBar,
  MAT_DIALOG_DATA,
  MatDialogConfig,
  MatPaginator,
} from "@angular/material";
import { ViewMediaPlanComponent } from "../view-media-plan/view-media-plan.component";
import { CreateMediaPlanComponent } from "../create-media-plan/create-media-plan.component";
import { EditMediaPlanComponent } from "../edit-media-plan/edit-media-plan.component";
import { ClipboardService } from "ngx-clipboard";
// import { Router } from '@angular/router';
@Component({
  selector: "app-view-media-plan-request",
  templateUrl: "./view-media-plan-request.component.html",
  styleUrls: ["./view-media-plan-request.component.scss"],
})
export class ViewMediaPlanRequestComponent implements OnInit {
  viewMediaPlanComponent: MatDialogRef<ViewMediaPlanComponent>;
  constructor(
    private _activatedRoute: ActivatedRoute,
    private _serverService: ServerService,
    private _router: Router,
    private dialog: MatDialog,
    private clipboardService:ClipboardService
  ) {}
  mediaRequestId: any;
  mediaRequestDetail: any;
  authToken = localStorage.getItem("token");
  showComponentLoader = true;
  createMediaPlanComponent: MatDialogRef<CreateMediaPlanComponent>;
  editMediaPlanComponent: MatDialogRef<EditMediaPlanComponent>;
  viewMediaDetailRequest: any;
  userInfo = JSON.parse(localStorage.getItem("userInfo"));
  copyButtonClicked = false
  project_copy = false
  location_copy = false
  ngOnInit() {
    this.viewMediaDetailRequest = {
      id: this.mediaRequestId,
      title: "mediaPlanRequest",
      titleView: "mediaPlanRequest",
      parent: "mediaPlanRequest",
      commentType: "mediaPlanRequest",
    };
    this._activatedRoute.params.subscribe((params: any) => {
      this.mediaRequestId = params.id;
      this.viewMediaDetailRequest = {
        id: this.mediaRequestId,
        title: "mediaPlanRequest",
        titleView: "mediaPlanRequest",
        parent: "mediaPlanRequest",
        commentType: "mediaPlanRequest",
      };
      this.getMediaRequestDetailById();
    });
    // console.log(this.viewMediaDetailRequest)
  }
  getMediaRequestDetailById() {
    let url = "media_plan_request/" + this.mediaRequestId;
    this._serverService.getMediaRequestById(url, this.authToken).subscribe(
      (data) => {
        this.mediaRequestDetail = data;

        this.showComponentLoader = false;
      },
      (error: any) => {
        if (error.status === 404) {
          this._router.navigate(["page/media_plan"]);
        } else {
          console.error("Error fetching Media Plan Rquest details:", error);
        }
      }
    );
  }
  editMediaPlan(mediaPlan: any, mediaPlanRequest: any) {
    // console.log(mediaPlanRequest)
    mediaPlan["mediaPlanRequest"] = mediaPlanRequest;
    this.editMediaPlanComponent = this.dialog.open(EditMediaPlanComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: "820px",
      minWidth: "820px",
      panelClass: "cdk-overlay-panel-right-side",
      data: mediaPlan,
    });
    this.editMediaPlanComponent.afterClosed().subscribe((result) => {
      if (result != undefined) {
        this.showComponentLoader = true;
        this.getMediaRequestDetailById();
      }
    });
  }
  getStatusContainerBgColor(status: any) {
    if (status) {
      switch (status.toLowerCase()) {
        case "approved":
          return "rgba(164, 214, 201, 1)";
        case "cancelled":
          return "rgba(126, 28, 28, 1)";
        default:
          return "rgba(158, 158, 158, 0.26)";
      }
    }
  }
  getStatusContainerColor(status: any) {
    if (status) {
      switch (status.toLowerCase()) {
        case "approved":
          return "rgba(7, 98, 74, 1)";
        case "cancelled":
          return "rgba(225, 225, 225, 1)";
        default:
          return "rgba(95, 95, 95, 1)";
      }
    }
  }
  back() {
    this._router.navigate(["page/media_plan"]);
  }
  CommaInNumber(number: any) {
    if (number != null) {
      number = Number(number);
      let temp = number.toLocaleString("en-IN");
      return temp;
    }
  }
  salesReportingManager(data: any) {
    if (data) {
      let temp = data.map((data) => {
        return data.name;
      });
      return temp.join(", ");
    }
  }
  viewMediaPlan(plans: any, media_request: any) {
    plans["all_media_plan_request_data"] = media_request;
    this.viewMediaPlanComponent = this.dialog.open(ViewMediaPlanComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: "820px",
      minWidth: "820px",
      panelClass: "cdk-overlay-panel-right-side",
      data: plans,
    });
  }
  downloadFile(data: any) {
    this.showComponentLoader = true;
    fetch(data.plan_sheet_link)
      .then((response) => response.blob())
      .then((blob) => {
        var link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = data.plan_sheet_name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
        this.showComponentLoader = false;
      })
      .catch((error) => console.error("Download error:", error));
  }
  createMediaPlan(data: any) {
    if (
      (data.assigned_user.id == this.userInfo.id || this.userInfo.admin) &&
      data.status.toLowerCase() != "cancelled"
    ) {
      this.createMediaPlanComponent = this.dialog.open(
        CreateMediaPlanComponent,
        {
          hasBackdrop: true,
          disableClose: false,
          autoFocus: true,
          width: "820px",
          minWidth: "820px",
          panelClass: "cdk-overlay-panel-right-side",
          data: data,
        }
      );
      this.createMediaPlanComponent.afterClosed().subscribe((result) => {
        if (result != undefined) {
          this.showComponentLoader = true;
          this.getMediaRequestDetailById();
        }
      });
    }
  }
  cnvrttoString(): any {
    return this.mediaRequestDetail.typology
      .map((item) => `${item.configuration} - ${item.price}`)
      .join(" | ");
  }
  copyText(item:any,key:any){
    // console.log(this.copyButtonClicked)
    this.clipboardService.copyFromContent(item);
    if(key == 'project'){
      this.project_copy = true;
      this.location_copy = false;
    }
    if(key == 'location'){
      this.location_copy = true;
      this.project_copy = false
    }
    // this.copyButtonClicked = true;
  }
}
